import { Component } from "react";
import { BrandError } from "./BrandStates";

// Bounded app/route-level error boundary. Catches technical render/chunk-load
// failures and shows the branded recoverable error. It never handles auth or
// authorization: those are expressed as <Navigate> redirects in ProtectedRoute,
// not thrown errors, so permission failures stay distinct and are never
// swallowed here. No stack traces, provider details, secrets, internal IDs or
// learner information are ever surfaced to the UI.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, resetKey: props.resetKey };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // Reset the boundary when the route changes (so navigating "home"/away
  // recovers) without remounting the whole Routes tree.
  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.resetKey) {
      return { hasError: false, resetKey: props.resetKey };
    }
    return null;
  }

  componentDidCatch() {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("Recoverable render error caught by boundary.");
    }
  }

  reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      return <BrandError onRetry={this.reset} />;
    }
    return this.props.children;
  }
}
